export default __webpack_public_path__ + "static/media/img-bg-grid-dark.43af653a.svg";